import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MarketingEventsIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "MarketingEvents",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M27.05 6.52h-5.27l.13-1.12a.41.41 0 0 0-.35-.46h-1.11c-.16-.31-.36-.59-.6-.83C18.72 2.98 17.3 2 14.21 2c-6 .04-10.84 4.93-10.8 10.94v.32c0 2.11 0 6.55 3.41 6.55.77.09 1.53-.2 2.04-.78 1.22-1.62.54-5.36.31-6.65-.19-1.05-.23-5.27.76-6.32a6.12 6.12 0 0 1 4.68-2.64c1.45-.18 2.91.26 4.01 1.22.13.11.26.19.37.29h-.64c-.23 0-.41.18-.42.4v.08l.72 4.67c.03.2.2.36.41.36h1.91c.21 0 .38-.16.41-.37l.11-.82h2.33c.49 0 .9.4.9.9v.08c0 .49-.4.89-.9.9h-7.76c-.5 0-.9-.4-.91-.9v-.07c0-.5.41-.91.91-.91h1.63l-.42-2.74h-4.64c-.86 0-1.55.69-1.55 1.55v20.38c0 .86.69 1.55 1.55 1.55h14.42c.85 0 1.54-.69 1.54-1.54V8.07c0-.85-.68-1.54-1.53-1.55zM8.79 5.57c-1.17 1.19-1.17 4.39-1.01 6.38s.72 2.71.43 5.01c-.11.84-.51 1.54-1.36 1.54-1.5 0-2.11-1.86-2.11-5.27 0-3.84 2.56-7.88 4.52-8.43.23.15-.28.53-.47.76Zm11.12 16.48a4.213 4.213 0 0 1-4.27-4.16 4.213 4.213 0 0 1 4.16-4.27 4.213 4.213 0 0 1 4.27 4.16v.1a4.21 4.21 0 0 1-4.16 4.16Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M5.29 26c-1.89 0-3.43-1.54-3.43-3.43v-8a1.14 1.14 0 1 1 2.28 0v8a1.14 1.14 0 1 0 2.28 0v-16c0-3.15 2.56-5.71 5.71-5.71h4.57c2.52 0 4.57 2.05 4.57 4.57v1.14a1.14 1.14 0 1 1-2.28 0V5.43c0-1.26-1.03-2.29-2.29-2.29h-4.57c-1.89 0-3.43 1.54-3.43 3.43v16C8.7 24.46 7.16 26 5.27 26Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M20.14 19.14c-2.52 0-4.57-2.05-4.57-4.57S17.62 10 20.14 10s4.57 2.05 4.57 4.57-2.05 4.57-4.57 4.57m0-6.86c-1.26 0-2.29 1.03-2.29 2.29s1.03 2.29 2.29 2.29 2.29-1.03 2.29-2.29-1.03-2.29-2.29-2.29M23.57 23.71h-6.86a1.14 1.14 0 1 1 0-2.28h6.86a1.14 1.14 0 1 1 0 2.28"
      }), /*#__PURE__*/_jsx("path", {
        d: "M25.86 30.57H14.43c-1.89 0-3.43-1.54-3.43-3.43V8.86c0-1.89 1.54-3.43 3.43-3.43h1.14a1.14 1.14 0 1 1 0 2.28h-1.14c-.63 0-1.14.51-1.14 1.14v18.29c0 .63.51 1.14 1.14 1.14h11.43c.63 0 1.14-.51 1.14-1.14V8.86c0-.63-.51-1.14-1.14-1.14h-1.14a1.14 1.14 0 1 1 0-2.28h1.14c1.89 0 3.43 1.54 3.43 3.43v18.29c0 1.89-1.54 3.43-3.43 3.43Z"
      })]
    })
  }));
};
MarketingEventsIcon.displayName = 'MarketingEventsIcon';